import { OpenInNew } from '@mui/icons-material'
import { MenuItem } from '@mui/material'

import useStyles from './index.styles'

const ExternalLinkMenuItem = ({ label, href, onClick }: { label: string; href?: string; onClick?: () => void }) => {
  const classes = useStyles

  if (href)
    return (
      <MenuItem component="a" href={href} onClick={onClick} target="_blank" sx={classes.menuItemWithIcon}>
        {label}
        <OpenInNew fontSize="small" color="action" sx={classes.leftSpaceIcon} />
      </MenuItem>
    )
  if (onClick)
    return (
      <MenuItem onClick={onClick} sx={classes.menuItemWithIcon}>
        {label}
        <OpenInNew fontSize="small" color="action" sx={classes.leftSpaceIcon} />
      </MenuItem>
    )
  return null
}

export default ExternalLinkMenuItem
